import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from '../../shared/index';
import { FormElementProfile } from '../shared/model/profile/form-element-profile.model';
import { IFormBuilderProfileDisplayElement } from '../shared/model/form-builder-shared.model';

@Component({
  selector: 'wl-form-builder-profile-display-element',
  templateUrl: 'form-builder-profile-display-element.component.html',
  //providers: [FormBuilder, UtilService, NotificationService, FormElementTypes, FormFields, NavigationService]
    standalone: false
})
export class FormBuilderProfileDisplayElementComponent implements IFormBuilderProfileDisplayElement {
  @Input('relatedProfileSettings') relatedProfileSettings: FormElementProfile;
  private _translationService: TranslationService;

  //public relatedProfileSettings: FormElementProfile;

  public constructor(translationService: TranslationService) {
    this._translationService = translationService;
  }

  ngOnInit(): void {
    //this.relatedProfileSettings = this._host.relatedProfileSettings;
  }
}
